// Session-local data only. Never persist private DTOs or share them between accounts/personas.
const entries = new Map();
let scope;
const TTL = 30_000;
function scoped() {
  const next = `${localStorage.getItem('accessToken') || ''}|${localStorage.getItem('pr.activePage') || ''}`;
  if (next !== scope) { entries.clear(); scope = next; }
  return entries;
}
export function clearRouteData() { entries.clear(); }
export function peek(key) { return scoped().get(key)?.value; }
export function put(key, value) {
  scoped().set(key, { value, at: Date.now(), promise: Promise.resolve(value), settled: true });
  if (entries.size > 80) entries.delete(entries.keys().next().value);
  return value;
}
export function prefetch(key, loader, { force = false } = {}) {
  const cache = scoped();
  const hit = cache.get(key);
  if (hit && (!hit.settled || (!force && Date.now() - hit.at < TTL))) return hit.promise;
  const entry = { at: Date.now(), value: hit?.value, settled: false };
  entry.promise = Promise.resolve().then(loader).then(value => {
    entry.value = value; entry.settled = true; entry.at = Date.now();
    return value;
  }, error => {
    // A rejected prefetch must be retryable, including a speculative pointerdown.
    if (cache.get(key) === entry) cache.delete(key);
    throw error;
  });
  cache.set(key, entry);
  if (cache.size > 80) cache.delete(cache.keys().next().value);
  return entry.promise;
}
export function requireData(result) {
  if (!result?.success) throw new Error(typeof result?.error === 'string' ? result.error : result?.error?.message || "Couldn't load this page.");
  return result.data;
}
export function storedLocation() {
  try { return JSON.parse(localStorage.getItem('pr.userLocation')) || {}; } catch { return {}; }
}
export const locationKey = () => { const l = storedLocation(); return `${l.lat ?? ''},${l.lng ?? ''}`; };
